import type { SignInRequest } from "./types";

export type AuthConfig =
  | { readonly mode: "explicit" }
  | {
    readonly mode: "auto";
    readonly autoLoginCredentials: SignInRequest;
  };

/**
 * Per-developer auth behavior loaded from Vite's `.env.local` config.
 * Explicit login is the safe default; auto-login is development-only.
 */
export function loadAuthConfig(): AuthConfig {
  const rawMode = import.meta.env.VITE_CAMPFIRE_AUTH_MODE?.trim().toLowerCase();
  const mode = rawMode || "explicit";

  if (mode !== "explicit" && mode !== "auto") {
    throw new Error(
      `[authConfig] VITE_CAMPFIRE_AUTH_MODE must be "explicit" or "auto", got "${mode}".`,
    );
  }
  if (mode === "explicit") return { mode };
  if (!import.meta.env.DEV) {
    throw new Error("[authConfig] Auto-login is allowed only in development builds.");
  }

  const email = import.meta.env.VITE_CAMPFIRE_AUTO_LOGIN_EMAIL?.trim();
  const password = import.meta.env.VITE_CAMPFIRE_AUTO_LOGIN_PASSWORD;
  if (!email || !password) {
    throw new Error(
      "[authConfig] Auto-login requires VITE_CAMPFIRE_AUTO_LOGIN_EMAIL and "
      + "VITE_CAMPFIRE_AUTO_LOGIN_PASSWORD in .env.local.",
    );
  }

  return {
    mode,
    autoLoginCredentials: { email, password },
  };
}
